"use client";

import React, { type ReactElement } from "react";

import { DebouncedInput } from "@rootreeweb/rui-forms";

import { useSearch } from "../lib/useSearch.js";
import type { InteractiveFAQProps } from "../types.js";
import Category from "./Category.js";
import Question from "./Question.js";

/**
 * The client rendered display of the FAQ.
 *
 * @param props The props for the component.
 * @returns The component.
 */
export default function InteractiveFAQ(
	props: InteractiveFAQProps,
): ReactElement {
	const { current, search, setSearch } = useSearch(props);
	return (
		<>
			<DebouncedInput
				additionalWrapperProps={{
					className:
						"p-0" /*Intentionally unprefixed for specificity in WordPress*/,
				}}
				label={"Search"}
				onInput={(e) => {
					setSearch(e.currentTarget.value);
				}}
				value={search}
			/>
			<div className="faq:mt-4">
				{current.map((item) =>
					"questions" in item ? (
						<Category
							category={item}
							faqProps={props.faqProps}
							key={item.id}
							lang={props.lang}
						/>
					) : (
						<Question
							faqProps={props.faqProps}
							lang={props.lang}
							question={item}
						/>
					),
				)}
			</div>
		</>
	);
}
